import { DataGrid } from "@mui/x-data-grid";
import {
  Chip,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import useFetch from "../hooks/useFetch";

export default function Sales() {
  const fetchData = useFetch();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [revenue, setRevenue] = useState("");
  const [quantity, setQuantity] = useState("");

  const columns = [
    { field: "referenceCode", headerName: "Product", flex: 1 },
    { field: "quantity", headerName: "Aantal", width: 100 },
  ];

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  const getData = async () => {
    setLoading(true);
    const response = await fetchData("/api/sales");
    if (response) {
      setData(response.orders);
      setRevenue(response.totalValue.replace(".", ","));
      setQuantity(response.totalQuantity);
    }
    setLoading(false);
  };

  const isInPWA =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;

  useEffect(() => {
    function handleVisibilityChange() {
      if (document.visibilityState === "visible" && isInPWA) {
        getData();
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <Container maxWidth={"xs"}>
      <Grid container spacing={1} sx={{ mb: 2 }}>
        <Grid size={6} sx={{ display: "flex", justifyContent: "center" }}>
          <Chip
            label={`€${revenue !== "" ? revenue : "799,11"}`}
            sx={{
              fontSize: "1.1rem",
              px: 2.5,
              py: 1,
              height: "auto",
              filter: revenue !== "" ? "none" : "blur(4px)",
              opacity: revenue !== "" ? 1 : 0.9,
              transition: "all 0.8s ease-in-out",
              ".MuiChip-label": {
                padding: 0,
              },
            }}
            color="info"
          />
        </Grid>
        <Grid size={6} sx={{ display: "flex", justifyContent: "center" }}>
          <Chip
            label={`${quantity !== "" ? `${quantity} verkopen` : "65 verkopen"}`}
            sx={{
              fontSize: "1.1rem",
              px: 2.5,
              py: 1,
              height: "auto",
              filter: quantity !== "" ? "none" : "blur(4px)",
              opacity: quantity !== "" ? 1 : 0.9,
              transition: "all 0.8s ease-in-out",
              ".MuiChip-label": {
                padding: 0,
              },
            }}
            variant={"outlined"}
            color="info"
          />
        </Grid>
      </Grid>

      <DataGrid
        rows={data}
        columns={columns}
        getRowId={(row) => row.referenceCode}
        density="compact"
        loading={loading}
        sx={{
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
        }}
      />
    </Container>
  );
}
